// Footer component
import React, { useState } from 'react';

const Footer = () => {
  const [email, setEmail] = useState('');

  return (
    <footer style={{ backgroundColor: '#002d5a' }} className="text-white">
      {/* Desktop View - Hidden on Mobile */}
      <div className="hidden md:block">
        <div className="max-w-[85rem] mx-auto px-8 py-12">
          <div className="flex justify-between items-start">
            {/* Left Section - Logo and Description */}
            <div className="flex items-start space-x-4 flex-1">
              <div className=" bg-teal-600 rounded-full flex items-center justify-center flex-shrink-0">
                <img  src='images/seal.png' style={{width:'80px', height: '80px'}} />
              </div>
              <div className="max-w-md">
                <p className="text-white text-sm italic leading-relaxed">
                  This site is maintained by the Administrative Office of the U.S. Courts on behalf of the Federal Judiciary.
                </p>
              </div>
            </div>

            {/* Right Section - Subscribe */}
            <div className="flex-1 max-w-md">
              <h3 className="text-xl font-semibold text-white mb-4" style={{fontFamily: 'Source Serif Pro'}}>Subscribe to Updates</h3>
              <p className="text-white text-sm mb-6 leading-relaxed">
                To receive updates, enter your email address and select the topics that interest you.
              </p>
              <div className="flex">
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="flex-1 px-4 py-2 rounded-l-full text-gray-900 focus:outline-none"
                  placeholder=""
                />
                <button 
                  style={{ backgroundColor: '#0057a3' }}
                  className="px-6 py-2 text-white rounded-r-full hover:bg-blue-700 transition-colors"
                >
                  Submit
                </button>
              </div>
            </div>
          </div>

          {/* Bottom Section */}
          <div className="mt-12 pt-8">
            <div className="flex justify-between items-center">
              {/* Footer Links */}
              <div className="flex space-x-8">
                <a href="#" className="text-white hover:text-gray-300 transition-colors">
                  Privacy & Security Policy
                </a>
                <span className="text-white">|</span>
                <a href="#" className="text-white hover:text-gray-300 transition-colors">
                  Operating Status
                </a>
                <span className="text-white">|</span>
                <a href="#" className="text-white hover:text-gray-300 transition-colors">
                  Download Plug-Ins
                </a>
              </div>

              {/* Social Icons */}
              <div className="flex space-x-6">
                <a href="#" className="text-white hover:text-gray-300 transition-colors">
                  <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
                  </svg>
                </a>
                <a href="#" className="text-white hover:text-gray-300 transition-colors">
                  <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
                  </svg>
                </a>
                <a href="#" className="text-white hover:text-gray-300 transition-colors">
                  <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                  </svg>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Mobile View - Hidden on Desktop */}
      <div className="md:hidden">
        <div className="px-6 py-8">
          {/* Logo and Description */}
          <div className="flex items-start space-x-4 mb-8">
            <div className=" bg-teal-600 rounded-full flex items-center justify-center flex-shrink-0">
              <img  src='images/seal.png' style={{width:'80px', height: '80px'}} />
            </div>
            <p className="text-white text-sm italic leading-relaxed">
              This site is maintained by the Administrative Office of the U.S. Courts on behalf of the Federal Judiciary.
            </p>
          </div>

          {/* Footer Links */}
          <div className="space-y-4 mb-12 pt-8">
            <a href="#" className="block text-white hover:text-gray-300 transition-colors">
              Privacy & Security Policy
            </a>
            <a href="#" className="block text-white hover:text-gray-300 transition-colors">
              Operating Status
            </a>
            <a href="#" className="block text-white hover:text-gray-300 transition-colors">
              Download Plug-Ins
            </a>
          </div>

          {/* Subscribe Section */}
          <div className="mb-8">
            <h3 className="text-xl font-semibold text-white mb-4" style={{fontFamily: 'Source Serif Pro'}}>Subscribe to Updates</h3>
            <p className="text-white text-sm mb-6 leading-relaxed">
              To receive updates, enter your email address and select the topics that interest you.
            </p>
            <div className="flex">
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="flex-1 px-4 py-2 rounded-l-full text-gray-900 focus:outline-none"
                placeholder=""
              />
              <button 
                style={{ backgroundColor: '#0057a3' }}
                className="px-6 py-2 text-white rounded-r-full hover:bg-blue-700 transition-colors"
              >
                Submit
              </button>
            </div>
          </div>

          {/* Social Icons */}
          <div className="flex justify-between space-x-12 mt-12">
            <a href="#" className="text-white hover:text-gray-300 transition-colors">
              <svg className="w-8 h-8" fill="currentColor" viewBox="0 0 24 24">
                <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
              </svg>
            </a>
            <a href="#" className="text-white hover:text-gray-300 transition-colors">
              <svg className="w-8 h-8" fill="currentColor" viewBox="0 0 24 24">
                <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
              </svg>
            </a>
            <a href="#" className="text-white hover:text-gray-300 transition-colors">
              <svg className="w-8 h-8" fill="currentColor" viewBox="0 0 24 24">
                <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
              </svg>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;